import * as React from 'react';
import * as reduxApi from 'src/utils/redux-api-v2';
import {useDispatch} from 'react-redux';
import {useApi} from 'src/hooks/useApi';
import {useClipboard} from 'src/hooks/useClipboard';
import {Card} from '@spaced-out/ui-design-system/lib/components/Card';
import {Input} from '@spaced-out/ui-design-system/lib/components/Input';
import {
  FormLabelSmall,
  SubTitleMedium,
  SubTitleSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Textarea} from '@spaced-out/ui-design-system/lib/components/Textarea';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import {
  Toast,
  ToastTitle,
  toastApi,
} from '@spaced-out/ui-design-system/lib/components/Toast';

import css from './sense-ai.css';


export default function SenseAi() {
  const dispatch = useDispatch();
  const [jobTitle, setJobTitle] = React.useState('');
  const [outputJd, setOutputJd] = React.useState({});
  const [prompts, setPrompts] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
  const [_hasCopiedJd, handleJdCopy] = useClipboard(outputJd?.job_description);

  const handleGenerateJd = () => {
    setIsLoading(true);
    const toastJsx = (
      <Toast semantic="success">
        <ToastTitle> JD generated sucessfully for {jobTitle} </ToastTitle>
      </Toast>
    );

    dispatch(
      reduxApi.post('sense-ai/job-description/generate', {
        job_title: jobTitle,
        // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
        input_jd: outputJd?.job_description,
        prompts,
      }),
    )
      .then((json) => {
        setOutputJd(json);
        setIsLoading(false);
        setPrompts('');
        toastApi.show(toastJsx);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const getPrompts = useApi<string[]>(
    'sense-ai/job-description/prompt-examples',
  );

  const getContentsEnhanncements = useApi<string[]>(
    'sense-ai/job-description/content-enhancements',
    {
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      deps: [outputJd?.jd_id],
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      shouldFetch: !!outputJd?.jd_id,
    },
  );
  const postEnhancement = useApi(
    // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
    `sense-ai/job-description/enhance/${outputJd?.jd_id}`,
    {
      method: 'POST',
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      deps: [outputJd?.jd_id],
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      shouldFetch: !!outputJd?.jd_id,
    },
  );
  const getMatrix = useApi<string[]>(
    // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
    `sense-ai/job-description/metrics/${outputJd?.jd_id}`,
    {
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      deps: [outputJd?.jd_id],
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      shouldFetch: !!outputJd?.jd_id,
    },
  );

  const getSuggestResponsibilitiesProps = useApi<string[]>(
    'sense-ai/job-description/suggest-prompts',
    {
      method: 'POST',
      data: {
        job_title: jobTitle,
        // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
        input_jd: outputJd?.job_description,
        get_responsibilities: true,
        get_skills: false,
      },
      // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
      deps: [outputJd?.job_description, jobTitle],
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      shouldFetch: !!outputJd?.jd_id,
    },
  );
  const getSuggestSkillsProps = useApi<string[]>(
    'sense-ai/job-description/suggest-prompts',
    {
      method: 'POST',
      data: {
        job_title: jobTitle,
        // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
        input_jd: outputJd?.job_description,
        get_skills: true,
        get_responsibilities: false,
      },
      // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
      deps: [outputJd?.job_description, jobTitle],
      // @ts-expect-error - TS2339 - Property 'jd_id' does not exist on type '{}'.
      shouldFetch: !!outputJd?.jd_id,
    },
  );

  // @ts-expect-error - TS7030 - Not all code paths return a value.
  const getDefaultPercentageColor = (percentage: unknown) => {
    // @ts-expect-error - TS18046 - 'percentage' is of type 'unknown'.
    if (percentage <= 40) {
      return 'danger';
      // @ts-expect-error - TS18046 - 'percentage' is of type 'unknown'. | TS18046 - 'percentage' is of type 'unknown'.
    } else if (percentage > 40 && percentage <= 80) {
      return 'warning';
      // @ts-expect-error - TS18046 - 'percentage' is of type 'unknown'.
    } else if (percentage > 80) {
      return 'success';
    }
  };

  return (
    <div className={css.container}>
      <div className={css.containerHeader}>
        <Card classNames={{wrapper: css.cardWrapper}}>
          {}
          <div className={css.spaceBetween}>
            <Input
              classNames={{box: css.jdName}}
              placeholder={'Job Title'}
              onChange={(e) => setJobTitle(e.target.value)}
            ></Input>
            {}
            {/* @ts-expect-error - TS2339 - Property 'jd_completion_score' does not exist on type 'string[]'. */}
            {getMatrix.result?.jd_completion_score && (
              <SubTitleMedium
                color={getDefaultPercentageColor(
                  // @ts-expect-error - TS2339 - Property 'jd_completion_score' does not exist on type 'string[]'.
                  getMatrix.result?.jd_completion_score,
                )}
                className={css.percentComplete}
              >
                {}
                {/* @ts-expect-error - TS2339 - Property 'jd_completion_score' does not exist on type 'string[]'. */}
                {getMatrix.result?.jd_completion_score} % Complete
              </SubTitleMedium>
            )}
            <div className={css.btn}>
              <Button
                type="secondary"
                onClick={() => handleJdCopy()}
                // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
                disabled={!outputJd?.job_description}
              >
                Copy
              </Button>
            </div>
          </div>
        </Card>
      </div>
      <div>
        <Card classNames={{wrapper: css.cardWrapper}}>
          <div className={css.leftItems}>
            <div className={css.promptBox}>
              <Textarea
                label="Prompt"
                placeholder=""
                size="medium"
                onChange={(e) => setPrompts(e.target.value)}
                value={prompts}
              />
              <Button
                iconRightName="bolt"
                disabled={!jobTitle || isLoading}
                onClick={() => handleGenerateJd()}
              >
                <div className={css.generateJdButton}>
                  {/* @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'. */}
                  {outputJd?.job_description ? 'Enhance JD' : 'Generate JD'}
                  {isLoading && <CircularLoader size="small" />}
                </div>
              </Button>
            </div>
            <div className={css.suggestions}>
              {/* @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'. */}
              {outputJd?.job_description ? (
                <>
                  <Sections
                    setPrompts={setPrompts}
                    prompts={prompts}
                    title="Add Missing Sections"
                    isLoading={getMatrix?.isLoading}
                    sections={
                      (getMatrix &&
                        getMatrix.result &&
                        // @ts-expect-error - TS2339 - Property 'jd_missing_sections' does not exist on type 'string[]'.
                        getMatrix.result.jd_missing_sections.length > 0 &&
                        // @ts-expect-error - TS2339 - Property 'jd_missing_sections' does not exist on type 'string[]'.
                        getMatrix.result.jd_missing_sections) ||
                      []
                    }
                  />
                  <Sections
                    setPrompts={setPrompts}
                    prompts={prompts}
                    title="Content Enhancements"
                    isLoading={getContentsEnhanncements?.isLoading}
                    sections={
                      (getContentsEnhanncements &&
                        getContentsEnhanncements.result &&
                        getContentsEnhanncements.result.length > 0 &&
                        getContentsEnhanncements.result) ||
                      []
                    }
                  />
                  <Sections
                    setPrompts={setPrompts}
                    prompts={prompts}
                    title="Responsibilities"
                    isLoading={getSuggestResponsibilitiesProps?.isLoading}
                    sections={
                      (getSuggestResponsibilitiesProps &&
                        getSuggestResponsibilitiesProps.result &&
                        getSuggestResponsibilitiesProps.result.length > 0 &&
                        getSuggestResponsibilitiesProps.result) ||
                      []
                    }
                  />
                  <Sections
                    setPrompts={setPrompts}
                    prompts={prompts}
                    title="Skills"
                    isLoading={getSuggestSkillsProps?.isLoading}
                    sections={
                      (getSuggestSkillsProps &&
                        getSuggestSkillsProps.result &&
                        getSuggestSkillsProps.result.length > 0 &&
                        getSuggestSkillsProps.result) ||
                      []
                    }
                  />
                </>
              ) : (
                <Sections
                  setPrompts={setPrompts}
                  prompts={prompts}
                  title="Exmaple"
                  isLoading={getPrompts?.isLoading}
                  sections={
                    (getPrompts &&
                      getPrompts.result &&
                      getPrompts.result.length > 0 &&
                      getPrompts.result) ||
                    []
                  }
                />
              )}
            </div>
          </div>
          <div className={css.rightItems}>
            <Textarea
              label="Job Description"
              placeholder="Paste your JD here if you already have one or write a prompt beside to generate JD here"
              classNames={{box: css.jdDescriptionBox}}
              // @ts-expect-error - TS2339 - Property 'job_description' does not exist on type '{}'.
              value={outputJd ? outputJd?.job_description : ''}
              onChange={(e) =>
                setOutputJd({
                  ...outputJd,
                  job_description: e.target.value,
                })
              }
            />
          </div>
        </Card>
      </div>
    </div>
  );
}

// @ts-expect-error - TS7031 - Binding element 'sections' implicitly has an 'any' type. | TS7031 - Binding element 'title' implicitly has an 'any' type. | TS7031 - Binding element 'isLoading' implicitly has an 'any' type. | TS7031 - Binding element 'setPrompts' implicitly has an 'any' type. | TS7031 - Binding element 'prompts' implicitly has an 'any' type.
const Sections = ({sections, title, isLoading, setPrompts, prompts}) => {
  if (!isLoading && (!sections || sections.length === 0)) {
    return null;
  }

  return (
    <div className={css.promptListContainer}>
      <SubTitleSmall>{title}</SubTitleSmall>
      {isLoading && <CircularLoader size="small" />}
      {!isLoading &&
        sections &&
        sections.length > 0 &&
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        sections.map((item) => {
          return (
            <div
              className={css.promptList}
              onClick={() => {
                setPrompts(`${prompts}${prompts ? ',' : ''}${item}`);
              }}
            >
              <Icon name="bolt" />
              <FormLabelSmall> {item}</FormLabelSmall>
            </div>
          );
        })}
    </div>
  );
};
